import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';

import Utils from 'src/app/utils';

import timezones from 'timezones-list';

declare var require: any;
declare var bootstrap: any;


@Component({
  selector: 'app-worker-info',
  templateUrl: './worker-info.component.html',
  styleUrls: ['./worker-info.component.scss']
})
export class WorkerInfoComponent implements OnInit {

  @Input() worker:any;

  @Output() refreshWorker = new EventEmitter();

  formGroup = new FormGroup({
    name: new FormControl('',[Validators.required]),
    email: new FormControl('',[Validators.email]),
    phone: new FormControl('',[]),
    cell: new FormControl('',[]),
    country: new FormControl(null,[]),
    timezone: new FormControl(null,[]),
    monitors: new FormControl('',[Validators.required]),
    alert_loop: new FormControl('',[]),
    groups: new FormControl([],[]),
    vehicle_id: new FormControl(null,[]),
    information: new FormControl('',[]),
  })

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  countryListArray  = Utils.getCountries();
  timezoneListArray = timezones;

  loading_vehicle = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, public transloco: TranslocoService) { }

  ngOnInit(): void {


    if(this.okService.settings.arc_on){
      this.formGroup.setControl('email',new FormControl('',[Validators.email,Validators.required])),
      this.formGroup.setControl('phone',new FormControl('',[Validators.required]))
    }

    if(this.okService.settings.arc_on && this.worker.status.working){
      this.formGroup.disable();
    }

    this.setForm();

  }
  
  ngAfterViewInit()	: void {
    Utils.setupPopover();
  }

  setForm(){



    this.formGroup.setValue({
      name: this.worker.name,
      phone: this.worker.phone,
      cell: this.worker.cell,
      email: this.worker.email,
      country: this.worker.country,
      timezone: this.worker.timezone,
      monitors: this.worker.monitors,
      alert_loop: this.worker.alert_loop,
      groups: this.worker.group_ids,
      vehicle_id: this.worker.vehicle_id,
      information: this.worker.information
    });

    if(!this.okService.hasMonitorWorkerAccess('workers','update')){
      
      this.formGroup.controls['name'].disable();
      this.formGroup.controls['phone'].disable();
      this.formGroup.controls['cell'].disable();
      this.formGroup.controls['email'].disable();
      this.formGroup.controls['country'].disable();
      this.formGroup.controls['timezone'].disable();
      this.formGroup.controls['monitors'].disable();
      this.formGroup.controls['groups'].disable();
      this.formGroup.controls['vehicle_id'].disable();
      this.formGroup.controls['information'].disable();

    }

    this.setupMonitorLimit();

  }

  submitForm(){
    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values = this.formGroup.value
        //console.log(values);

        this.okService.put("workers/"+this.worker.id,values)
        .subscribe((data) => {

          this.worker = data.body;

          //console.log("worker",this.worker);
          //console.log("monitors",this.worker.monitors);
          //console.log("vehicle",this.worker.vehicle_id);
          this.setForm();
          this.refreshWorker.emit();

          this.okService.setAlert(this.transloco.translate("The worker has been updated"),"success");


        });

      }

    return false;
  }

  sendWelcome(){

    this.okService.post("workers/welcome/"+this.worker.id,{})
    .subscribe((data) => {

      this.okService.setAlert(this.transloco.translate("The worker welcome email/SMS has been sent"),"success");

    });
  }

  imageUploaded(){
    //console.log("The image has been uploaded");

    var myModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('imageModal'));
    myModal.hide();

    this.refreshWorker.emit();

    this.okService.setAlert(this.transloco.translate("The worker profile image has been updated"),"success");

  }

  removeImage(){
    
    this.okService.put("workers/profileupload/"+this.worker.id,{},{delete:true})
    .subscribe((data) => {

      this.refreshWorker.emit();

      this.okService.setAlert(this.transloco.translate("The worker profile image has been removed"),"success");

    });
  }

  updateVehicle(){
    this.loading_vehicle = true;

    this.okService.get("workers/updatevehicle/"+this.worker.id,{})
    .subscribe((data:any) => {

      let worker = data.body;

      this.formGroup.patchValue({vehicle_id: worker.vehicle_id});

      this.refreshWorker.emit();

      this.loading_vehicle = false;

      this.okService.setAlert(this.transloco.translate("Vehicle updated from Geotab if one is available"),"success");

    });

  }

  // If monitors number is equal to or less than 4 set a validator limit of 4
  // If monitors is 4 or greater then put an alert mentioning that 4 is the preferred limit
  setupMonitorLimit(){

    if(!this.okService.isFromAdmin()){

      let numOfMonitors = this.worker.monitors.length;

      let maxMonitors = 5;
      if(this.okService.settings.id < 4000){
        maxMonitors = 10;
      }

      if(numOfMonitors <= maxMonitors){
        this.formGroup.get('monitors')!.addValidators(Validators.maxLength(maxMonitors));
      }
    }

  }

}
